import SystemCustomDivider from "../../dividers/SystemCustomDivider";
import LevelASubCardHeaderText from "../../texts/levelAScreen/LevelASubCardHeaderText";
import LevelAExampleQuestionText from "../../texts/levelAScreen/LevelAExampleQuestionText";
import LevelAExamplePicture from "./LevelAExamplePicture";
import {get_nested} from "../../../services/JsonHandler";
import {useState} from "react";
import LevelAExampleZoomedPictureDialog from "../../dialogs/levelAScreen/LevelAExampleZoomedPictureDialog";

export default function LevelAExampleQuestion({question, picture, isTextCentered}) {
    // Used in LevelAExample to display LevelA Knowledge question

    // PROPERTIES
    // ---- Modal
    const [isPictureModalOpen, setIsPictureModalOpen] = useState(false)
    // ---- Picture
    const pictureUrl = get_nested(['filePath'], picture, null)

    // BUILD
    return (
        <div className={"w-3/5 min-h-[128px] bg-primaryDark7/30 border-[1px] border-greyLight1 flex flex-col justify-start items-start px-[16px] pt-[12px] pb-[16px] rounded-[12px]"}>
            {/** MODAL */}
            <LevelAExampleZoomedPictureDialog open={isPictureModalOpen}
                                              handleClose={() => setIsPictureModalOpen(false)}
                                              pictureUrl={pictureUrl} />
            {/** CONTENT */}
            <LevelASubCardHeaderText text={"Énoncé"} />
            <SystemCustomDivider color={"bg-greyLight5"} extraClass={"mt-[12px]"} />
            <div className={`w-full flex ${isTextCentered ? "h-full flex-col justify-center" : "justify-start"} items-center`}>
                <LevelAExampleQuestionText question={question} />
            </div>
            <LevelAExamplePicture pictureUrl={pictureUrl}
                                  openZoom={() => setIsPictureModalOpen(true)} />
        </div>
    );
}